export const isImage = (url) => {
  return url.match(/\.(jpg|jpeg|gif|png|tiff|bmp)$/)
}

export const isImageOrMp4 = (url) => {
  return isImage(url) || url.match(/\.mp4$/)
}

export const isValidURL = (url) => {
  return url.match(/^https?:\/\/.+/)
}

export const videoURLtoEmbed = (url: string, autoplay = false) => {
  const autoplayVideo = autoplay ? 1 : 0
  const vimeoRegexPattern = /vimeo\.com.*(?:videos|video|channels|)\/([\d]+)/i
  const youtubeRegexPattern =
    /(?:www.youtube.com\/watch\?v=|youtu\.be\/|www.youtube.com\/embed\/)([a-zA-Z0-9\-_]+)/

  const vimeoMatch = url.match(vimeoRegexPattern)
  const youtubeMatch = url.match(youtubeRegexPattern)

  if (youtubeMatch) {
    const videoId = youtubeMatch[1]
    return `https://www.youtube.com/embed/${videoId}?showinfo=0&autoplay=${autoplayVideo}&mute=1&loop=1&playlist=${videoId}`
  }

  if (vimeoMatch) {
    const videoId = vimeoMatch[1]
    return `https://player.vimeo.com/video/${videoId}?sidedock=0&autoplay=${autoplayVideo}&mute=1&loop=1&autopause=0`
  }

  return url
}

/**
 * Obtém os dados de CSRF das meta tags da página
 */
export const getCsrfParams = () => ({
  token: (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement)
    ?.content,
  param: (document.querySelector("meta[name='csrf-param']") as HTMLMetaElement)
    ?.content,
})
